// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","videoContainer":"Home_videoContainer__gVzY8","myVideo":"Home_myVideo__by2KT","Content":"Home_Content__Op+sD"};